// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3ZZel","errorLogs":"styles_errorLogs__1GteZ"};